interface ICabinCard {
  bookingInfo: any;
}

const CabinCard: React.FC<ICabinCard> = ({ bookingInfo }) => {

  if (!Number(bookingInfo?.room_count)) {
    return <span className="pl-5 no-rooms">No Cabin Data Available</span>
  }

  return (
    <div className="flex flex-col gap-3 w-100">
      {bookingInfo?.booking_room?.rooms?.map((cabinDetails: any, index: number, arr: any) => {
        return (
          <div key={index} className={`${index === arr.length - 1 ? "" : "border-b pb-3"}`}>
            <div className="flex gap-3 w-100">
              <div className="flex flex-col gap-3">
                <span className="text-uppercase text-xl font-bold underline underline-offset-4 text-muted">{cabinDetails?.roomCategory?.name}</span>
                <div className="flex flex-col gap-3 text-base font-bold">
                  <span className="text-muted">Deck Number : {cabinDetails?.roomCategory?.rooms?.deck_no ? `0`+cabinDetails?.roomCategory?.rooms?.deck_no : 'N/A'}</span>
                  <span className="text-muted">Cabin Number : {cabinDetails?.roomCategory?.rooms?.number || 'N/A'}</span>
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default CabinCard;
